/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-sweetalert/~/react-redux/~/react/lib/ReactCurrentOwner.js
// module id = ./node_modules/react-redux-sweetalert/node_modules/react-redux/node_modules/react/lib/ReactCurrentOwner.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons